import script from "./InstallationServiceSatisfactionSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallationServiceSatisfactionSurvey.vue?vue&type=script&setup=true&lang=js"

import "./InstallationServiceSatisfactionSurvey.vue?vue&type=style&index=0&id=67006a92&scoped=true&lang=css"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67006a92"]])

export default __exports__